import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { AuthenticationConfigObject, WishlistProduct } from '@as-react/common-types';
import { QueryApiOptions, UrlMapping } from '../../types/types';
import { wishlistQueryKeys } from './wishlist.queries';
import { wishlistMutationKeys } from './wishlist.mutations';
import { createUrl } from '../../utils/createUrl';

export type WishlistSuggestionsParams = {
  query: string;
};

export type WishlistProductsParams = {
  showOutOfStock?: boolean;
};

export type WishlistLoginParams = AuthenticationConfigObject;
export type WishlistLogoutParams = AuthenticationConfigObject;

const wishlistEndpoints: UrlMapping<typeof wishlistQueryKeys & typeof wishlistMutationKeys> = {
  wishlistProducts: {
    client: 'api/wishlist/basic',
  },
  login: {
    client: 'api/wishlist/login',
  },
  logout: {
    client: 'api/wishlist/logout',
  },
};

export const getWishlistProducts = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  { showOutOfStock }: WishlistProductsParams
): Promise<Array<WishlistProduct>> => {
  const url = createUrl(servicesEndpoint, wishlistEndpoints.wishlistProducts, isServer);

  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    params: showOutOfStock ? { ...defaultRequestParams, showOutOfStock } : defaultRequestParams,
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);

  return result.data.products;
};

export const wishlistLogin = async (
  { servicesEndpoint, isServer }: QueryApiOptions,
  authenticationConfig: WishlistLoginParams
) => {
  const url = createUrl(servicesEndpoint, wishlistEndpoints.login, isServer);

  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url,
    params: authenticationConfig,
    withCredentials: true,
  };

  const result = await axiosClient.request<undefined>(axiosConfig);
  return result.data;
};

export const wishlistLogout = async (
  { servicesEndpoint, isServer }: QueryApiOptions,
  authenticationConfig: WishlistLogoutParams
) => {
  const url = createUrl(servicesEndpoint, wishlistEndpoints.logout, isServer);

  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url,
    params: authenticationConfig,
    withCredentials: true,
  };

  const result = await axiosClient.request<undefined>(axiosConfig);
  return result.data;
};
